<div>
  <!-- 🔹 Action Buttons -->
  <div style="margin-left: 80%; margin-bottom: 2%;">
    <button class="noPrint" style="margin: 2%;" (click)="excelToExportPostingLabel('Posting_Label_And_Statement_Report')"
      mat-raised-button color="primary">
      Export
    </button>

    <button class="noPrint" style="margin: 2%;" mat-raised-button color="primary" (click)="printPage()"
      printSectionId="print-section">
      Print
    </button>

    <button mat-dialog-close class="btn noPrint" style="margin: 2%;" mat-raised-button color="warn">Close</button>
  </div>

  <!-- 🔹 Print Section -->
  <div class="container" id="print-section">
    <ng-container *ngFor="let group of groupedData">
      <table class="table table-bordered"
        style="border: 2px solid black; border-collapse: collapse; width: 100%; margin-bottom: 30px;">
        <thead>
          <tr>
            <th colspan="5" style="font-size: 16px; font-weight: bold; border: 2px solid black; padding: 8px;">
              <span style="margin-right: 50px;">दिनांक: {{ currentDate | date:'dd/MM/yyyy HH:mm:ss' }}</span>
              हिंदुस्थान प्रकाशन संस्था विवेक साप्ताहिक
            </th>
          </tr>
          <tr>
            <th colspan="5" style="font-size: 15px; font-weight: bold; border: 2px solid black; padding: 8px;">
              <span style="margin-right: 480px;">पृष्ठ क्र:</span>
              <span *ngIf="(group.rep_name && group.rep_name.trim() !== '') || (group.office_rep_name && group.office_rep_name.trim() !== ''); else defaultText">
                नोंदणीदार - प्रतिनिधी - {{ rep_name ? group.rep_name : '' }} व कार्यालयीन वर्गणी - {{ office_rep_name ? group.office_rep_name : '' }} - वर्गणी जमा असलेले
              </span>
              <ng-template #defaultText>
                नोंदणीदार - प्रतिनिधी व कार्यालयीन वर्गणी
              </ng-template>
            </th>
          </tr>
          <tr>
            <th colspan="5" style="font-size: 14px; font-weight: bold; border: 2px solid black; padding: 8px;">
              <span style="margin-right: 110px;">वितरण - {{ delivery_mode ? group.delivery_mode : '' }}</span>
              <span style="margin-right: 232px;">
                {{ country ? group.country : '' }} - {{ state ? group.state : '' }} - {{ district ? group.district : '' }} - {{ taluka ? group.taluka : '' }}
              </span>
              <span style="margin-right: 240px;">अंक - विक्री  जमा असलेले</span>
              वितरण सांकेताकानुसार वर्गणीदार यादी - {{ Subscription_Type ? group.Subscription_Type : '' }}
            </th>
          </tr>
          <tr>
            <th style="text-align: center; font-weight: bold; font-size: 14px; border: 2px solid black; padding: 6px;">Month/Booking No</th>
            <th style="text-align: center; font-weight: bold; font-size: 14px; border: 2px solid black; padding: 6px;">Issue Seller Name</th>
            <th style="text-align: center; font-weight: bold; font-size: 14px; border: 2px solid black; padding: 6px;">Address</th>
            <th style="text-align: center; font-weight: bold; font-size: 14px; border: 2px solid black; padding: 6px;">Booking Date</th>
            <th style="text-align: center; font-weight: bold; font-size: 14px; border: 2px solid black; padding: 6px;">Mobile Number</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let item of group.items">
            <td style="border: 1px solid black; padding: 6px; ">{{ item.month }}/{{ item.subno }}</td>
            <td style="border: 1px solid black; padding: 6px; ">{{ item.name }}</td>
            <td style="border: 1px solid black; padding: 6px; ">
              {{ item.address }} {{ item.taluka }}, {{ item.district }} {{ item.state }} {{ item.country }}, {{ item.pincode }}
            </td>
            <td style="border: 1px solid black; padding: 6px; ">
               {{ item.booking_date | date:'dd/MM/yyyy' }}
            </td>
            <td style="border: 1px solid rgb(96, 86, 86); padding: 6px; ">{{ item.mobileNumber }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </div>
</div>
